#@export GliveBooking.Presenters.Info

class GliveBooking.Presenters.Info extends BookingV2.Presenters.Base

  module: 'glive-booking'

  toHash: ->
    selectedPrice = @model.get('selectedPrice')
    displayPrice = selectedPrice or @model.get('prices').getCheapest()
    quantity = 1
    discountEnabled = @model.discountEnabled()
    quantity = @model.get('selectedQuantity').getPartySize() if @model.get('selectedQuantity')?
    subtotal = displayPrice.getPrice() * quantity
    value = displayPrice.getValue() * quantity
    savings = quantity * displayPrice.getSavings()
    isReadyToBook = @model.isReadyToBook()

    optionSelected: selectedPrice?
    discountEnabled: discountEnabled
    price: @formatMoney subtotal, displayPrice.getPriceCurrencyCode()
    value: @formatMoney value, displayPrice.getValueCurrencyCode()
    discount: displayPrice.getDiscount()
    savings: @formatMoney savings, displayPrice.getPriceCurrencyCode()
    isReadyToBook: isReadyToBook

  formatMoney: (amountCents, currencyCode) ->
    formattedCurrency = I18n.toCurrency amountCents/100, {currencyCode}
    trailingZerosRegex = /[,\.]00(?!\d)/
    formattedCurrency.replace trailingZerosRegex, ""
